import type { NoiseFilterState } from '@cli-types/next-adapter/utils.js'
import { SUPPRESSIBLE_LINE_STARTS } from '@cli-constants/process-output.js'
import { stripAnsi } from '@cli-utils/text.js'

export function couldBecomeSuppressible(partial: string, state: NoiseFilterState): boolean {
  if (state.suppressingPgSslWarning || state.suppressNextTraceHint) {
    return true
  }

  const text = stripAnsi(partial, { stripCarriageReturns: true })
  return SUPPRESSIBLE_LINE_STARTS.some((start) => text.startsWith(start) || start.startsWith(text))
}
